import React, { useState, useEffect, useCallback, useContext } from "react";
import { AuthContext } from '../AuthContext';
import { Link } from "react-router-dom";
import s from '../styles/VehicleList.module.css';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faTrash, faPen, faFilter } from "@fortawesome/free-solid-svg-icons";

const VehicleList = () => {
  const { role } = useContext(AuthContext);
  const [vehicles, setVehicles] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filteredVehicles, setFilteredVehicles] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("Всего");
  const [statusCounts, setStatusCounts] = useState({ total: 0, process: 0, ready: 0 });

  const [filterServiceRequest, setFilterServiceRequest] = useState("Все"); // Фильтр по заявке в сервис
  const [searchQuery, setSearchQuery] = useState(""); // Поле поиска

  const [showModal, setShowModal] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(null);

    // ------------------
  // Новые состояния для фильтрации по марке, модели и т.д.
  // ------------------
  const [brandOptions, setBrandOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [typeOptions, setTypeOptions] = useState([]);
  const [colorOptions, setColorOptions] = useState([]);

  // Выбранные чекбоксы
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedModels, setSelectedModels] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [selectedColors, setSelectedColors] = useState([]);

  // // Модальные окна для каждого фильтра
  // const [showBrandModal, setShowBrandModal] = useState(false);
  // const [showModelModal, setShowModelModal] = useState(false);
  // const [showTypeModal, setShowTypeModal] = useState(false);
  // const [showColorModal, setShowColorModal] = useState(false);
  // Одно общее модальное окно для всех фильтров
const [showFiltersModal, setShowFiltersModal] = useState(false);


  const fetchVehicles = useCallback(async () => {
    try {
      const response = await fetch("/api/vehicles");
      if (!response.ok) throw new Error("Ошибка загрузки данных");
      const data = await response.json();
      setVehicles(data);
      countStatuses(data);
      setFilteredVehicles(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

   // ------------------
  // Фетч опций для чекбоксов
  // ------------------
  const fetchOptions = useCallback(async () => {
    try {
      // Марки
      const respBrands = await fetch("/api/vehicle/brands_no_arhiv");
      const brandsData = await respBrands.json();
      setBrandOptions(brandsData);

      // Модели
      const respModels = await fetch("/api/vehicle/models_no_arhiv");
      const modelsData = await respModels.json();
      setModelOptions(modelsData);

      // Типы
      const respTypes = await fetch("/api/vehicle/vehicle_types_no_arhiv");
      const typesData = await respTypes.json();
      setTypeOptions(typesData);

      // Цвета
      const respColors = await fetch("/api/vehicle/colors_no_arhiv");
      const colorsData = await respColors.json();
      setColorOptions(colorsData);
    } catch (error) {
      console.error("Ошибка загрузки фильтров:", error);
    }
  }, []);

  // 📌 Подсчет статусов
  const countStatuses = (vehicles) => {
    let total = vehicles.length;
    let process = vehicles.filter((v) => v.vehicle_status === "В процессе").length;
    let ready = vehicles.filter((v) => v.vehicle_status === "Готов").length;
    setStatusCounts({ total, process, ready });
  };

// ------------------
  // Вызываем при монтировании
  // ------------------
  useEffect(() => {
    fetchVehicles();
    fetchOptions();
  }, [fetchVehicles, fetchOptions]);

  // 📌 Открытие модального окна
  // const handleDeleteClick = (vehicle) => {
  //   setSelectedVehicle(vehicle);
  //   setShowModal(true);
  // };

  // 📌 Закрытие модального окна
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedVehicle(null);
  };

  const toggleBrand = (brand) => {
    setSelectedBrands((prev) =>
      prev.includes(brand) ? prev.filter((b) => b !== brand) : [...prev, brand]
    );
  };
  
  const toggleModel = (model) => {
    setSelectedModels((prev) =>
      prev.includes(model) ? prev.filter((m) => m !== model) : [...prev, model]
    );
  };
  
  const toggleType = (type) => {
    setSelectedTypes((prev) =>
      prev.includes(type) ? prev.filter((t) => t !== type) : [...prev, type]
    );
  };
  
  const toggleColor = (color) => {
    setSelectedColors((prev) =>
      prev.includes(color) ? prev.filter((c) => c !== color) : [...prev, color]
    );
  };
  

  // 📌 Удаление автомобиля
  const handleDeleteVehicle = async () => {
    if (!selectedVehicle) return;

    try {
      const response = await fetch(`/api/vehicles/delete/${selectedVehicle.id}`, {
        method: "DELETE",
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.error || "Ошибка при удалении");

      fetchVehicles(); // Обновляем список машин
      handleCloseModal(); // Закрываем модальное окно
    } catch (err) {
      setError(err.message);
    }
  };

  const resetAdvancedFilters = () => {
    // Сбрасываем выбранные чекбоксы
    setSelectedBrands([]);
    setSelectedModels([]);
    setSelectedTypes([]);
    setSelectedColors([]);
  

  };
  
  useEffect(() => {
    applyAllFilters();
  }, [selectedBrands, selectedModels, selectedTypes, selectedColors]);
  
  // ------------------
  // Применить фильтры (по марке, модели, типу, цвету)
  // ------------------
  const applyAllFilters = () => {
    let filtered = [...vehicles];

    // 1) Фильтр по статусу (старый)
    if (selectedStatus !== "Всего") {
      filtered = filtered.filter((v) => v.vehicle_status === selectedStatus);
    }

    // 2) Фильтр по наличию заявки
    if (filterServiceRequest === "С заявкой") {
      filtered = filtered.filter((v) => v.request_date && v.request_date.trim() !== "");
    } else if (filterServiceRequest === "Без заявки") {
      filtered = filtered.filter((v) => !v.request_date || v.request_date.trim() === "");
    }

    // 3) Поиск (VIN, марка, модель и т.д.)
    if (searchQuery.trim() !== "") {
      filtered = filtered.filter((v) =>
        v.vin.toLowerCase().includes(searchQuery.toLowerCase()) ||
        v.brand.toLowerCase().includes(searchQuery.toLowerCase()) ||
        v.model.toLowerCase().includes(searchQuery.toLowerCase()) ||
        v.vehicle_type.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (v.color && v.color.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (v.errors && v.errors.toLowerCase().includes(searchQuery.toLowerCase()))
      );
    }

    // 4) Фильтр по выбранным маркам
    if (selectedBrands.length > 0) {
      filtered = filtered.filter((v) => selectedBrands.includes(v.brand));
    }
    // 5) Фильтр по выбранным моделям
    if (selectedModels.length > 0) {
      filtered = filtered.filter((v) => selectedModels.includes(v.model));
    }
    // 6) Фильтр по выбранным типам
    if (selectedTypes.length > 0) {
      filtered = filtered.filter((v) => selectedTypes.includes(v.vehicle_type));
    }
    // 7) Фильтр по выбранным цветам
    if (selectedColors.length > 0) {
      filtered = filtered.filter((v) => selectedColors.includes(v.color));
    }

    setFilteredVehicles(filtered);
    countStatuses(filtered);
  };

  useEffect(() => {
    applyAllFilters();
  }, [vehicles, selectedStatus, filterServiceRequest, searchQuery]);


  if (loading) return <p>Загрузка...</p>;
  if (error) return <p style={{ color: "red" }}>Ошибка: {error}</p>;

  return (
    <div className={s.container}>
      {/* Фильтры */}
      <div className={s.filter_all}>
      <div className={s.inputWrapper}>
        <input
          type="text"
          placeholder="Поиск по списку"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className={s.searchInput}
        />
          <img src="search.svg" alt="Поиск" className={s.searchIcon} />
          </div>

        <select onChange={(e) => setFilterServiceRequest(e.target.value)} value={filterServiceRequest} className={s.filterSelect}>
          <option value="Все">Все заявки</option>
          <option value="С заявкой">С заявкой</option>
          <option value="Без заявки">Без заявки</option>
        </select>
      </div>

      <div className={s.filterButtons}>
      <button onClick={() => setShowFiltersModal(true)} className={s.filter_button}>
          <span className={s.iconWrapper_filter}>
          <img src="filter.svg" alt="icon" width={24} height={24} />
          </span>
          Фильтры
        </button>
        <button onClick={resetAdvancedFilters} className={s.filter_button_x}>
          x
        </button>
      </div>



      {/* Фильтр по статусу */}
      <div className={s.status}>
        <div className={s.statusItem} onClick={() => setSelectedStatus("Всего")} style={{flex: "1", cursor: "pointer", fontWeight: selectedStatus === "Всего" ? "bold" : "normal" }}>
          <p className={s.vehicleInfoP_ALL}>{selectedStatus === "Всего" && <span className={s.greenDot}></span>}Всего: <strong>{statusCounts.total}</strong></p>
        </div>
        <div className={s.statusItem} onClick={() => setSelectedStatus("В процессе")} style={{flex: "1", cursor: "pointer", fontWeight: selectedStatus === "В процессе" ? "bold" : "normal" }}>
        <p className={s.vehicleInfoP_proccess}> {selectedStatus === "В процессе" && <span className={s.greenDot}></span>}В процессе: <strong>{statusCounts.process}</strong></p>
        </div>
        <div className={s.statusItem} onClick={() => setSelectedStatus("Готов")} style={{flex: "1", cursor: "pointer", fontWeight: selectedStatus === "Готов" ? "bold" : "normal" }}>
        <p className={s.vehicleInfoP_gotovo}>{selectedStatus === "Готов" && <span className={s.greenDot}></span>}Готово: <strong>{statusCounts.ready}</strong></p>
        </div>
      </div>

      {/* Список автомобилей */}
      <div className={s.listContainer}>
        {filteredVehicles.map((vehicle) => (
          <div key={vehicle.id} className={s.item}>
           <div className={s.div_one}> 
          <Link key={vehicle.id} to={`/vehicles/${vehicle.id}`} className={s.vehicleCard}>
              
                  <div className={s.image_container}>
                  <img
                    src={vehicle.photo_3_4_front_left_url ? `${process.env.PUBLIC_URL}/vehicles/${vehicle.photo_3_4_front_left_url}` : "/vehicles/default.jpg"}
                    alt="Фото авто"
                    className={s.vehicleImage}
                  />
              </div>
              <div className={s.vehicleInfo}>
                <p className={s.vehicleInfoP}>{vehicle.vin}</p>
                <div className={s.div_Info}>
                  <div className={s.div_info_text}>
                      <p className={s.vehicleInfoP2}>{vehicle.color}</p>
                      <p className={s.vehicleInfoP2}>
                        {!vehicle.date_acceptance || vehicle.date_acceptance === "1970-01-01"
                          ? "Отсутствует"
                          : vehicle.date_acceptance.split("-").reverse().join("-")}
                      </p>
                  </div>
                    
                  {vehicle.vehicle_status === "Готов" ? (
                    <div className={s.vehicle_status_div}>
                      <img src="/shape_status.svg" alt="icon" width={16} height={16} />
                      <p className={s.statusReady}>{vehicle.vehicle_status}</p>
                    </div>
                  ) : null}
                </div>
              </div>
                </Link>
                  <div>
                        {/* Кнопка "Удалить" */}
                    {/* {role === "superadmin" || role === "admin" || role === "full" ? (
                      <div className={s.trash_div} >
                        <FontAwesomeIcon icon={faTrash} size="lg" color="red" onClick={() => handleDeleteClick(vehicle)} />
                      </div>
                    ) : null} */}
                    {role === "superadmin" || role === "admin" || role === "full" || role === "prefull"  || role === "office-manager" || role === "service" ? (
                       <Link key={vehicle.id} to={`/update/${vehicle.id}`} className={s.vehicleCard}>
                       <img src="shape.svg" alt="icon" width={18} height={18} />
                        </Link>
                    ) : null}
                    
                    
                  </div>
                </div>
            </div>
            

            
        ))}

        <div className={s.finish_div}>
        </div>
      </div>
      {/* Модальное окно подтверждения удаления */}
      {showModal && selectedVehicle && (
        <div className={s.modalOverlay}>
          <div className={s.modalContent}>
            <h3>Удалить автомобиль?</h3>
            <p><strong>{selectedVehicle.vin}</strong></p>
            <p>{selectedVehicle.brand} - {selectedVehicle.vehicle_type}</p>
            {error && <p className={s.error}>{error}</p>}
            <div className={s.modalButtons}>
              <button onClick={handleDeleteVehicle} className={s.confirmButton}>Удалить</button>
              <button onClick={handleCloseModal} className={s.cancelButton}>Отмена</button>
            </div>
          </div>
        </div>
      )}

{showFiltersModal && (
  <div className={s.modalOverlay}>
    <div className={s.modalContent}>
      <h3>Фильтры</h3>

      {/* Марки */}
      <section className={s.filterSection}>
        <h4 className={s.List_modal_h4}>Марки</h4>
        <div className={s.filterLabel_list_div}>
        {brandOptions.map((brand) => (
          <label key={brand} className={s.filterLabel_list}>
            <input className={s.checkbox}
              type="checkbox"
              checked={selectedBrands.includes(brand)}
              onChange={() => toggleBrand(brand)}
            />
            <span className={s.checkboxBox}></span>
            {brand}
          </label>
        ))}</div>
      </section>

      {/* Модели */}
      <section className={s.filterSection}>
        <h4 className={s.List_modal_h4}>Модели</h4>
        <div className={s.filterLabel_list_div}>
        {modelOptions.map((model) => (
          <label key={model} className={s.filterLabel_list}>
            <input className={s.checkbox}
              type="checkbox"
              checked={selectedModels.includes(model)}
              onChange={() => toggleModel(model)}
            />
            <span className={s.checkboxBox}></span>
            {model}
          </label>
        ))}</div>
      </section>

      {/* Типы */}
      <section className={s.filterSection}>
        <h4 className={s.List_modal_h4}>Типы</h4>
        <div className={s.filterLabel_list_div}>
        {typeOptions.map((type) => (
          <label key={type} className={s.filterLabel_list}>
            <input className={s.checkbox}
              type="checkbox"
              checked={selectedTypes.includes(type)}
              onChange={() => toggleType(type)}
            />
            <span className={s.checkboxBox}></span>
            {type}
          </label>
        ))}</div>
      </section>

      {/* Цвета */}
      <section className={s.filterSection}>
        <h4 className={s.List_modal_h4}>Цвета</h4>
        <div className={s.filterLabel_list_div}>
          {colorOptions.map((color) => (
          <label key={color} className={s.filterLabel_list}>
            <input className={s.checkbox}
              type="checkbox"
              checked={selectedColors.includes(color)}
              onChange={() => toggleColor(color)}
            />
            <span className={s.checkboxBox}></span>
            {color}
          </label>
        ))}
        </div>
        
      </section>
      <div className={s.footter}>

      </div>
      <div className={s.finish_div}>
      </div>

      {/* Кнопки управления */}
      <div className={s.modalButtons}>
        <button className={s.modalButton} onClick={() => { resetAdvancedFilters(); setShowFiltersModal(false); }}>
          Сбросить все
        </button>
        <button className={s.modalButton_x} onClick={() => { applyAllFilters(); setShowFiltersModal(false); }}>
        Применить
        </button>
      </div>
    </div>
  </div>
)}


    </div>
  );
};
   

export default VehicleList;
